import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getSalesReturnList } from "../../../../services/sales/salesService";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";

function SearchSalesReturn({
  warehouseID = 0,
  giStatus = 0,
  onSelectSalesReturn,
}) {
  const [salesReturn, setSalesReturn] = useState();
  const handleGetSalesReturn = async (warehouseID = 0, giStatus = 0) => {
    const response = await getSalesReturnList(0, 0, warehouseID, giStatus);
    const { data } = response.data;
    setSalesReturn(data.salesReturn);
  };
  useEffect(() => {
    handleGetSalesReturn(warehouseID, giStatus);
  }, [warehouseID, giStatus]);
  return (
    <CustomDataTableSearch
      data={salesReturn}
      onRefreshData={() => {
        handleGetSalesReturn(giStatus);
      }}
      onSelectedData={(salesReturn) => {
        if (onSelectSalesReturn) {
          onSelectSalesReturn(salesReturn);
        }
      }}
      columns={[
        {
          header: "Sales Return ID",
          field: "ID",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Sales Order ID",
          field: "salesOrderID",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Process Type",
          field: "processTypeName",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Return Date",
          field: "returnDate",
          body: (rowData) => formatDate(rowData.returnDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Sales Amount",
          field: "salesAmount",
          body: (rowData) => (
            <NumberFormat
              value={rowData.salesAmount}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
          filter: true,
        },
      ]}
    />
  );
}

export default SearchSalesReturn;
